import { PseudoLargerLetters } from "./PseudoLargerLetters";

export class I18nextPseudo implements i18next.PostProcessorModule {
    public name: string;
    public type: 'postProcessor';

    constructor(public enablePseudo: boolean) {
        this.name = 'pseudo';
        this.type = 'postProcessor';
    }

    public process(value: string): string {
        if (!this.enablePseudo) {
            return value;
        }
        const processedValue = value
            .split('')
            .map(character => {
                return Object.keys(PseudoLargerLetters).indexOf(character) !== -1 ?
                    PseudoLargerLetters[character as keyof typeof PseudoLargerLetters] : character;
            })
            .join('');

        return '[[ ' + processedValue + ' ]]';
    }
}
